import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { ReportFileService } from './report-file.service';

export const Ng1ReportFileModule = angular
  .module('control-room.shared.services.report-file', [])
  .factory('crReportFileService', downgradeInjectable(ReportFileService));
